module.exports = __webpack_public_path__ + "static/media/22-001.f88f4753.png";